import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'it'],

  // Used when no locale matches
  defaultLocale: 'it'
});

// Lightweight wrappers around Next.js' navigation APIs
// that consider the routing configuration above.
export const {Link, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);
